import { StandardTabsV2 } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useWorkpaperProcedureOverview } from '../../queries/use-workpaper-procedure-overview';

type ProceduresTabsProps = {
    onStatusChange: (statusFilter: string | null) => void;
};

const STATUS_FILTERS = ['ALL', 'ACTIVE', 'CHECKED', 'NOT_APPLICABLE'];

export default function ProceduresTabs({ onStatusChange }: ProceduresTabsProps): JSX.Element {
    const [selectedIndex, setSelectedIndex] = useState(0);

    const [query, setQuery] = useSearchParams();
    const tab = query.get('tab');

    const workpaperProcedureOverviewQuery = useWorkpaperProcedureOverview();
    const overview = workpaperProcedureOverviewQuery.data?.overview;

    function handleTabChange(idx: number): void {
        setSelectedIndex(idx);
        setQuery(
            (s) => {
                s.set('tab', (STATUS_FILTERS[idx] ?? 'all').toLowerCase());
                if (idx !== 0) {
                    s.delete('status');
                }
                return s;
            },
            { replace: true }
        );
        if (idx === 0) {
            onStatusChange(null);
            return;
        }
        onStatusChange(STATUS_FILTERS[idx]);
    }

    // When search changes set the tab index
    useEffect(() => {
        // If no tab value exists in the url default the tab index to 0
        if (!tab) {
            if (selectedIndex !== 0) {
                handleTabChange(0);
            }
        } else {
            const index = STATUS_FILTERS.indexOf(tab.toUpperCase());
            if (index !== selectedIndex) {
                handleTabChange(Math.max(index, 0));
            }
        }
    }, [selectedIndex, tab]);

    return (
        <div className="border-b">
            <StandardTabsV2 selectedIndex={selectedIndex} onChange={handleTabChange} name="procedure-status">
                <StandardTabsV2.Tab label={`All (${Object.values(overview || {}).reduce((acc, s) => s + acc, 0)})`} />
                <StandardTabsV2.Tab label={`Outstanding (${overview?.active ?? 0})`} />
                <StandardTabsV2.Tab label={`Completed (${overview?.checked ?? 0})`} />
                <StandardTabsV2.Tab label={`Not Applicable (${overview?.notApplicable ?? 0})`} />
            </StandardTabsV2>
        </div>
    );
}
